import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { Cake, Copy } from "lucide-react";

const MONTHS = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];

export default function BirthdaysCard() {
  const [month, setMonth] = useState(String(new Date().getMonth()+1).padStart(2,"0"));
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/birthdays", { params: { month } }).then(r=>setItems(r.data)).catch(()=>{});
  }, [month]);

  const wish = (u) => {
    if (!u.phone) return toast.error("Cliente sem telefone cadastrado");
    const phone = String(u.phone).replace(/\D/g, "");
    const first = (u.name || "").split(" ")[0];
    const msg = `Feliz aniversário, ${first}! 🌻✨ Todo o time do Arya Studio te deseja um dia lindo e cheio de mimos. Como presente, garantimos 15% OFF no próximo agendamento — é só apresentar essa mensagem! Beijos e até logo. 💛`;
    window.open(`https://wa.me/${phone.startsWith("55")?phone:"55"+phone}?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <div className="card-arya p-6">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Cake size={16} className="text-[color:var(--sun-600)]"/>
          <h3 className="font-serif text-xl">Aniversariantes</h3>
        </div>
        <select value={month} onChange={e=>setMonth(e.target.value)}
                className="rounded-xl border border-[var(--line)] bg-white px-2 py-1 text-xs" data-testid="birthday-month">
          {MONTHS.map((n,i)=><option key={i} value={String(i+1).padStart(2,"0")}>{n}</option>)}
        </select>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-[color:var(--ink-500)]">Nenhuma aniversariante em {MONTHS[Number(month)-1]}.</p>
      ) : (
        <ul className="divide-y divide-[var(--line)]">
          {items.map(u => (
            <li key={u.user_id} className="py-3 flex items-center justify-between" data-testid={`birthday-${u.user_id}`}>
              <div>
                <p className="font-display font-semibold">{u.name}</p>
                <p className="text-xs text-[color:var(--ink-500)]">{u.birthday} · {u.phone || "sem telefone"}</p>
              </div>
              <button onClick={()=>wish(u)} className="btn-ghost !py-1 !px-3 text-xs inline-flex items-center gap-1" data-testid={`wish-${u.user_id}`}>
                🌻 Parabenizar
              </button>
            </li>
          ))}
        </ul>
      )}
      <p className="text-[10px] text-[color:var(--ink-500)] mt-3">Envie uma mensagem carinhosa com 15% OFF de presente.</p>
    </div>
  );
}
